import React from 'react';
import { useTranslation } from 'react-i18next';
import { Mail } from 'lucide-react';

const ContactPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <main className="container mx-auto px-4 py-16 min-h-screen">
      <section className="max-w-2xl mx-auto">
        <h1 className="text-4xl font-bold mb-4 text-center text-gray-900 dark:text-white animate-fade-in">
          {t('contact.title')}
        </h1>
        <p className="text-xl text-gray-500 dark:text-gray-400 mb-8 text-center">
          {t('contact.subtitle')}
        </p>
        
        <div className="bg-gray-50 p-8 rounded-xl shadow-xl backdrop-blur-sm dark:bg-gray-900/50">
          <div className="flex flex-col items-center justify-center space-y-6">
            <Mail size={48} className="text-primary" />
            
            <p className="text-gray-700 dark:text-gray-300 text-center text-xl">
              {t('contact.emailText')}
            </p>
            
            <a 
              href="mailto:hello@notely.se" 
              className="text-primary hover:text-primary/90 text-2xl font-semibold transition-colors duration-200"
            >
              hello@notely.se
            </a>
            
            <p className="text-gray-500 dark:text-gray-400 text-center mt-6">
              {t('contact.responseText')}
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactPage;